Vue.component('pager', {
    props: ['postData', 'idx'],
    template: '#section-page-template'
})

new Vue({
    el: '#vue-section',
    data: {
        posts: [],
        page: 1,
        loading: false,
        finish: false,
        id: null,
        name: null,
        isSelected: false,
        isReady: false,
        actions: [],
        message: null,
        errormessage: null,
        isSubscriber: false,
        loginUrl: null,
        showSubscribe: false,
        subscriberId: null,
        subscribeSuccess: false
    },
    beforeMount: function () {
        this.isReady = false;
        this.id = parseInt(this.$el.attributes['data-match-id'].value);
        this.name = this.$el.attributes['data-term-name'].value;
        this.isSelected = this.$el.attributes['data-term-is-selected'].value === "True" ? true : false;
        this.loginUrl = this.$el.attributes['data-loginurl'].value;
        this.isSubscriber = this.$el.attributes['data-issubscriber'].value === "True" ? true : false;
    },
    updated: function () {
        lazyLoadInit();
        onResize();
        epicaAddEventClick('#vue-section');
    },
    mounted: function () {
        this.isReady = true;
        onResize();
        epicaAddEventClick('#vue-section');
    },
    methods: {
        getPosts: function (offset) {
            this.page++;
            this.loading = true;
            this.$http.get('/api/pager/term?page=' + this.page + '&id=' + this.id + '&offset=' + offset).then(function (response) {
                this.posts = this.posts.concat(response.body);
                this.loading = false;
                this.finish = response.body.length == 0;
            }, function (response) {

            });
        },
        clearMsg: function () {
            this.message = null;
            this.actions = [];
        },
        execute: function (item) {
            if (item.exec) {
                switch (item.exec) {
                    case 'subscribe':
                        this.showSubscribe = true;
                        break;
                    default:
                        break;
                }
            }
        },
        closeSubscribe: function () {
            this.showSubscribe = false;
        },
        addTopic: function () {
            var topic = {
                id: this.id,
                Name: this.name
            };

            this.$http.post('/api/lrplus/topics', topic).then(function (response) {
                topic.IsLoading = false;

                if (response.body.success) {
                    topic.IsSelected = true;
                    this.message = "Tema agregado satisfactoriamente.";
                    setTimeout(this.clearMsg, 3000);
                } else {
                    switch (response.body.errorCode) {
                        case "limit":
                            this.message = this.isSubscriber ? "Ha superado el límite de temas" : "Ha superado el límite de temas, suscribase para poder agregar más.";
                            if (!this.isSubscriber) {
                                this.actions.push({ title: "Suscribirse", exec: "subscribe" });
                                this.actions.push({ title: "Administrar Temas", href: "//mas.larepublica.co/temas" });
                            }
                            setTimeout(this.clearMsg, 10000);
                            break;
                        case "auth":
                            this.message = "Debe ingresar para agregar el tema.";
                            this.actions.push({ title: "ingresar", href: this.loginUrl });
                            setTimeout(this.clearMsg, 10000);
                            break;
                        default:
                            this.message = "Ha ocurrido un error, intente de nuevo más tarde.";
                            setTimeout(this.clearMsg, 3000);
                            break;
                    }
                }

            }, function (response) {
                topic.IsLoading = false;
                this.message = "Ha ocurrido un error, intente de nuevo más tarde.";
                setTimeout(this.clearMsg, 3000);
            });
        },
        subscribe: function () {
            if (this.subscriberId) {
                var subscriber = {
                    Identification: this.subscriberId
                };
                this.$http.post('/api/lrplus/subscribe', subscriber).then(function (response) {
                    if (response.body.success) {
                        this.subscribeSuccess = true;

                    } else {
                        this.errormessage = response.body.errorMessage;
                        setTimeout(this.clearErrorMessage, 5000);
                    }
                }, function (response) {
                    this.errormessage = "Ha ocurrido un error por favor intente de nuevo más tarde";
                    setTimeout(this.clearErrorMessage, 5000);
                });
            } else {
                this.errormessage = "Ingrese su número de identificación para poder continuar";
                setTimeout(this.clearErrorMessage, 5000);
            }
        },
        clearErrorMessage: function () {
            this.errormessage = null;
        }
    }
});